import React from 'react';
import './richContext.scss';

type MealSlot = { slot: string; dish: string };
type DayPlan = { date: string; meals: MealSlot[] };

type Props = {
  p: { days: DayPlan[] };
};

const MealPlanWeekContent: React.FC<Props> = ({ p }) => {
  return (
    <div className="rc-content-body">
      {(p.days as DayPlan[]).map((day, i) => (
        <div key={i} className="rc-meal-plan-day">
          <span className="rc-meal-plan-date">{day.date}</span>
          {(day.meals as MealSlot[]).map((meal, j) => (
            <div key={j} className="rc-list-row">
              <span className="rc-meal-slot">{meal.slot}</span>
              <span className="rc-list-text">{meal.dish}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default MealPlanWeekContent;
